<template>
	<div class="gov-title">
		<div class="gov-title1">
			<div class="gov-title2 right-title-2">
				<div>服务类型</div>
				<div>
          <el-checkbox-group @change="changeServiceType" v-model="serviceTypeId" :disabled="setTitle=='查看'">
            <el-checkbox label="信息服务">信息服务</el-checkbox>
            <el-checkbox label="实体服务">实体服务</el-checkbox>
          </el-checkbox-group>
				</div>
			</div>
			<div class="gov-title2 right-title-2 right-title-3">
				<div>服务状态</div>
				<div>
					<el-select @change="wUpdata" v-model="addForm.serviceStatus" placeholder="请选择" size="mini">
						<el-option label="带签约" :value="0"></el-option>
						<el-option label="在用" :value="1"></el-option>
						<el-option label="注销" :value="2"></el-option>
					</el-select>
				</div>
			</div>
		</div>
		<div class="gov-title1">
			<div class="gov-title2">
				<div>用户手机套餐</div>
				<div>
					<el-select @change="wUpdata" v-model="addForm.customerPhonePlan" placeholder="请选择" size="mini">
						<el-option label="带签约" :value="0"></el-option>
						<el-option label="在用" :value="2"></el-option>
						<el-option label="注销" :value="3"></el-option>
					</el-select>
				</div>
			</div>
			<div class="gov-title2 right-title-3">
				<div>用户手机型号</div>
				<div>
					<el-select @change="wUpdata" v-model="addForm.customerPhoneModel" placeholder="请选择" size="mini">
						<el-option label="带签约" :value="0"></el-option>
						<el-option label="在用" :value="2"></el-option>
						<el-option label="注销" :value="3"></el-option>
					</el-select>
				</div>
			</div>
		</div>
		<div class="gov-title1">
			<div class="gov-title2">
				<div>用户享受的服务类别</div>
				<div>
					<el-select @change="wUpdata" v-model="addForm.enjoyServiceCategoty" placeholder="请选择" size="mini">
						<el-option label="带签约" :value="0"></el-option>
						<el-option label="在用" :value="2"></el-option>
						<el-option label="注销" :value="3"></el-option>
					</el-select>
				</div>
			</div>
			<div class="gov-title2 right-title-3 right-title-4">
				<div>政府援助次数</div>
				<div>
					<el-input @blur="wUpdata" v-model="addForm.zfAssistanceNum" type="number" :min="0" size="mini" placeholder="请输入"></el-input>
				</div>
			</div>
		</div>
		<div class="gov-title5 right-title-3 right-title-4">
			<div>状态变更原因</div>
			<div>
				<el-input @blur="wUpdata" v-model="addForm.statusChangeReason" size="mini" type="textarea" :rows="3"></el-input>
			</div>
		</div>
		<div class="gov-title5 right-title-3 right-title-4">
			<div>审核拒绝原因</div>
			<div>
				<el-input @blur="wUpdata" v-model="addForm.reviewRefuseReason" size="mini" type="textarea" :rows="3"></el-input>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
    props:{
      setTitle:{
        type:String,
        default:''
      },
      formData: {
        customerPhonePlan: 0,
        serviceStatus: 0,
        customerPhoneModel: 0,
        zfAssistanceNum: 0,
        statusChangeReason: '',
        reviewRefuseReason: '',
      }
    },
		data(){
			return{
				addForm:{},
        serviceTypeId: []
			}
		},
    watch: {
      formData: {
        handler(val) {
          if(val.id) {
            this.addForm = val.zfAssistance
            this.serviceTypeId = this.addForm.serviceType.split(',')
            this.wUpdata()
          }
          if(val.hide) {
            this.addForm = {
              customerPhonePlan: 0,
              serviceStatus: 0,
              customerPhoneModel: 0,
              zfAssistanceNum: 0,
              statusChangeReason: '',
              reviewRefuseReason: '',
            }
            this.serviceTypeId = []
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      changeServiceType(val) {
        this.$set(this.addForm, 'serviceType', val.join(','))
        this.wUpdata()
      },
      wUpdata() {
        // console.log(this.addForm)
        this.$emit('governmentAssistance', this.addForm)
      }
    }
	}
</script>

<style lang="less" scoped>
	.gov-title{
		width: 98%;
		margin-left: 2%;
	}
	.gov-title1{
		width: 100%;
		display: flex;
	}
	.gov-title2{
		width: 50%;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #C0C4CC;
	}
	.gov-title2>div:first-child{
		width: 140px;
		height: 50px;
		line-height: 50px;
		border-right: 1px solid #C0C4CC;
		border-left: 1px solid #C0C4CC;
		text-align: center;
		background-color: #EEEEEE;
		
	}
	.gov-title2>div:nth-child(2) {
		height: 50px;
		line-height: 50px;
		margin-left: 20px;
	}
	.right-title-2{
		border-top: 1px solid #C0C4CC;
	}
	.right-title-3 {
		border-right: 1px solid #C0C4CC;
	}
	.right-title-4{
		/deep/.el-input__inner {
			border: none;
		}
	}
	.gov-title5{
		width: 100%;
		display: flex;
		
		border-bottom: 1px solid #C0C4CC;
	}
	.gov-title5>div:first-child{
		width: 140px;
		height: 80px;
		line-height: 80px;
		border-right: 1px solid #C0C4CC;
		border-left: 1px solid #C0C4CC;
		text-align: center;
		background-color: #EEEEEE;
		
	}
	.gov-title5>div:nth-child(2){
		width: calc(100% - 140px);
		
		/deep/.el-textarea__inner {
			border: none;
			resize: none;
		}
	}
</style>
